import {
  SAVE_DRAFT_CONFIGURATION,
  SAVE_DRAFT_CONFIGURATION_SUCCESS,
  SAVE_DRAFT_CONFIGURATION_ERROR,
  SAVE_DRAFT_CONFIGURATION_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SaveDraftConfiguration = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_DRAFT_CONFIGURATION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SAVE_DRAFT_CONFIGURATION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SAVE_DRAFT_CONFIGURATION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SAVE_DRAFT_CONFIGURATION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SaveDraftConfiguration;
